import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { User } from '../models/AdministrativeModels';

const initialUser = User.fromJSON({});
const initialAuthToken = localStorage.getItem('auth_token');

const initialState = {
	authToken: initialAuthToken,
	user: initialUser,
	isAuthorized: Boolean(initialAuthToken),
	isActive: Boolean(initialUser?.isActive),
	isImpersonating: false,
	status: 'idle',
	error: null
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthState(state, action) {
			const { authToken, user, isAuthorized, isActive, isImpersonating } = action.payload || {};
			state.authToken = authToken || null;
			state.user = user || User.fromJSON({});
			state.isAuthorized = Boolean(isAuthorized);
			state.isActive = Boolean(isActive);
			state.isImpersonating = Boolean(isImpersonating);
		},
		clearAuthState(state) {
			state.authToken = null;
			state.user = User.fromJSON({});
			state.isAuthorized = false;
			state.isActive = false;
			state.isImpersonating = false;
			state.status = 'idle';
			state.error = null;
		},
		setAuthStatus(state, action) {
			state.status = action.payload || 'idle';
		},
		setAuthError(state, action) {
			state.error = action.payload || null;
		},
		patchAuthUserUiTheme(state, action) {
			if (state.user) {
				state.user = _.extend(User.fromJSON({}), state.user, { uiTheme: action.payload });
			}
		}
	}
});

export const { setAuthState, clearAuthState, setAuthStatus, setAuthError, patchAuthUserUiTheme } = authSlice.actions;
export const selectAuthState = (state) => state.auth;
export const selectAuthUser = (state) => state.auth.user;
export const selectActivePersonaId = (state) => {
	const personaId = state.auth?.user?.persona?.id;
	return personaId == null ? null : personaId;
};
export const selectIsAuthorized = (state) => state.auth.isAuthorized;
export const selectIsActive = (state) => state.auth.isActive;
export const selectIsImpersonating = (state) => state.auth.isImpersonating;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;
export default authSlice.reducer;
